//@ts-ignore
import { AccessControl } from '@careinfo/permission-required';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
// @ts-ignore
import { TableSettingsLayout } from "@careinfo/layout";
import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import UploadIcon from '../UploadIcon';
import Template from './loading';
// import { useDebounce } from "../../../../customHooks/useDebounceHook";

import { useDebounce } from '../DatePicker/helpers/customHooks/useDebounceHook';
import useGetHook from '../DatePicker/helpers/customHooks/useGetHook';
import CreateIcon from '../../../Icons/CreateIcon';
import { classNames, responsiveClassName } from '../../../utils/classNames';

interface IDataTable {
  url: string;
  queryKey: string;
  columns: any;
  addNewPagePath?: string;
  tableName: string;
  params?: any;
  scanComponent?: any;
  actionMenu?: any;
  setRerender?: any;
  isUpload?: boolean;
  isDownload?: boolean;
  onRowClick?: (row: any) => void;
}

function DataTable(props: IDataTable) {
  const {
    url,
    queryKey,
    columns,
    addNewPagePath,
    scanComponent,
    actionMenu,
    tableName,
    params: otherParams,
    isUpload = false,
    isDownload = false,
    onRowClick,
  } = props;

  const [searchParams, setSearchParams] = useSearchParams({
    limit: '10',
    page: '0',
    searchQuery: '',
  });

  const [limit, setLimit] = useState<number>(10);
  const page = parseInt(searchParams.get('page') ?? '0', 10);
  const searchQuery = searchParams.get('searchQuery') ?? '';
  const [isOpenTableSetting, setIsOpenTableSettings] = useState(false);
  const selectedItems = searchParams.get('selectedItems');
  const debouncedSearch = useDebounce(searchQuery);
  const navigate = useNavigate();

  const [countSelectedItems, setSelectedItems] = useState<string[]>([]);
  const { register, setError, handleSubmit } = useForm();

  useEffect(() => {
    const items = selectedItems?.split(',') ?? [];
    setSelectedItems(items);
  }, [selectedItems]);

  const { data: serverData, isLoading } = useGetHook({
    queryKey: [
      queryKey,
      `${queryKey}-${limit}-${page}-${debouncedSearch}-${JSON.stringify(
        otherParams
      )}`,
    ],
    url,
    params: {
      limit,
      offset: limit * page,
      search: debouncedSearch,
      ...otherParams,
    },
  });

  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    if (Array.isArray(serverData?.results)) {
      setData([...serverData.results]);

      if (searchParams.get('selectAllItems') === '1') {
        const _newItems = serverData.results
          .map((item: any) => item.id)
          .join(',');
        setSearchParams({
          page: page.toString(),
          selectedItems: _newItems,
          selectAllItems: '1',
          searchQuery,
        });
      }
    }
  }, [serverData]);

    // Create the table and pass your options
  const table = useReactTable({
    data,
    columns,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const handleAddPageRoute = () => {
    navigate(addNewPagePath);
  };

  useEffect(() => {
    table.setPageSize(limit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  const handleNextPage = () => {
    searchParams.set('page', String(page + 1));
    setSearchParams(searchParams);
  };

  const handlePreviousPage = () => {
    searchParams.set('page', String(page - 1));
    setSearchParams(searchParams);
  };

  const handleLastpage = () => {
    searchParams.set('page', String(Math.floor(serverData?.count / limit)));
    setSearchParams(searchParams);
  };

  const handleFirstPage = () => {
    searchParams.set('page', '0');
    setSearchParams(searchParams);
  };

  const handleSearch = (value) => {
    searchParams.set('searchQuery', value);
    searchParams.set('page', '0');
    setSearchParams(searchParams);
  };
  const handleUploadExcel = () => {
    navigate('/bulk-upload');
  };

  return isLoading ? (
    <Template addNewPath={addNewPagePath} limit={limit} />
  ) : (
    <>
      {addNewPagePath && (
        <div className={tw`w-full flex justify-between`}>
          <AccessControl allowedPermissions={['can_create_consignment']}>
            <button
              onClick={handleAddPageRoute}
              className={tw`p-2 flex gap-x-2 bg-primary-light my-2 rounded text-primary focus:outline-none`}
            >
              <CreateIcon color={'var(--primary)'} />
              Add New
            </button>
          </AccessControl>
          {countSelectedItems ? (
              <>
                <div
                  className={tw`text-primary gap-x-4 flex items-center justify-center`}
                >
                  {/* <span>Selected Items:{countSelectedItems ?? 0}</span> */}
                  {/* <button
                    className={tw`focus:outline-none px-4 py-1 border-1 border-primary rounded-md flex items-center justify-center`}
                    onClick={() => {
                      const clonedParams = new URLSearchParams(searchParams);
                      clonedParams.delete('selectAllItems');
                      clonedParams.delete('selectedItems');
                      setSearchParams(clonedParams);
                    }}
                  >
                    Unselect All
                  </button> */}
                </div>
              </>
            ) : (
              tw``
            )}
          
          {scanComponent}
        </div>
      )}
      <div
        className={tw`w-full bg-white rounded-sm mb-8`}
        style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}
      >
        <div className={tw`w-full grid grid-cols-1 gap-4 md:flex justify-between items-center p-4`}>
          <div className={tw`mr-2`}>
            <input
              type='text'
              placeholder='Search'
              value={searchQuery ?? ""}
              onChange={(e) => handleSearch(e?.target?.value)}
              className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
            />
          </div>
          <div className={responsiveClassName('text-primary w-full flex flex-col gap-y-2 ', 'text-primary w-full justify-end items-center flex gap-x-4 ')}>
            <div className={tw`flex items-center gap-y-2 gap-x-1 w-full cursor-pointer`}>
              {actionMenu}
            </div>
            
            <TableSettingsLayout
              isOpenTableSetting={isOpenTableSetting}
              setIsOpenTableSettings={setIsOpenTableSettings}
              tableName={tableName}
              defaultColumns={columns}
              onSettingsLoaded={(settings: any) => {
                if (settings?.page_limit != null) {
                  setLimit(settings.page_limit);
                  searchParams.set("limit", settings.page_limit.toString());
                  setSearchParams(searchParams);
                }
              }}
            />
       
            <AccessControl
              children={
                <>
                  {isUpload && (
                    <button
                      className='flex gap-x-1 cursor-pointer text-primary focus:outline-none'
                      onClick={handleUploadExcel}
                    >
                      <UploadIcon color={'var(--primary)'} />
                      Upload
                    </button>
                  )}
                </>
              }
              allowedPermissions={['can_download']}
            />
          </div>
        </div>
        <div className={tw`w-full overflow-auto z-0`}>
          <table className={tw`w-full`}>
            <thead className={tw`bg-primary text-white uppercase`}>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header, index) => (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      className={classNames(
                        index === 0 ? tw`` : headerGroup.headers?.length - 1 === index ? tw` text-left w-[8rem]` : tw``,
                        tw`py-[5px] px-5 text-left w-[8rem] whitespace-nowrap`
                      )}
                    >
                      {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  onClick={() => onRowClick && onRowClick(row)}
                  style={{ cursor: onRowClick ? 'pointer' : 'default' }}
                  className={tw`tweven:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-all`}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className={tw`py-[10px] text-left px-5 `}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination logic */}
        <div className={tw`flex bg-white py-2 my-4 w-full justify-center gap-4`}>
          <button className={tw`border hidden md:block rounded p-1`} onClick={() => handleFirstPage()} disabled={!serverData?.previous}>{'<<'}</button>
          <button className={tw`border rounded p-1`} onClick={() => handlePreviousPage()} disabled={!serverData?.previous || page === 0}>{'<'}</button>
          <button className={tw`border rounded p-1`} onClick={() => handleNextPage()} disabled={!serverData?.next || page + 1 >= Math.ceil(serverData?.count / limit)}>{'>'}</button>
          <button className={tw`border hidden md:block rounded p-1`} onClick={() => handleLastpage()} disabled={!serverData?.next}>{'>>'}</button>
          <span className={tw`flex items-center gap-1`}>
            <div>Page</div>
            <strong>{page + 1} of {Math.ceil(serverData?.count / limit)}</strong>
          </span>
           {/* <span className="flex items-center gap-1">
              | Go to page:
              <input
                type="number"
                min={1}
                value={page}
                max={Math.ceil(serverData?.count/limit)}
                onChange={e => {setPage(Number(e.target.value))}}
                className="border p-1 rounded w-16"
              />
            </span> */}
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              searchParams.set('limit', e?.target?.value);
              setSearchParams(searchParams);
            }}
          >
            {[10, 50, 100, 200, 500].map((pageSize) => (
              <option key={pageSize} value={pageSize}>Show {pageSize}</option>
            ))}
          </select>
          <p className={tw`mt-1`}>All: {serverData?.count}</p>
        </div>
      </div>
    </>
  );
}

export default DataTable;